<script>
export let iconPath
</script>

<div class="fixed bottom-1 left-0 w-full px-4 py-6 bg-player-gradient bg-cover">
  <div class="flex items-center justify-start gap-3">
    <img src="{iconPath}" class="w-9 h-9 rounded-full object-center object-cover" alt="クリエイターアイコン" />
    <div class="flex flex-col items-start justify-center gap-1">
      <a href="/" class="text-xs font-bold text-white no-underline">
        <slot name="name" />
      </a>
      <a href="/" class="text-sm font-medium text-site-sub-black no-underline">
        <slot name="slug" />
      </a>
    </div>
  </div>
  <h1 class="mt-3 text-sm font-medium text-white">
    <slot name="title" />
  </h1>
</div>
